import script from "./ToggleSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=ba9f9dde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba9f9dde"]])

export default __exports__